/**
 * Peripheral Device Detection Reducer
 */

import {
  SET_PERIPHERAL_RESTRICTION_ACTIVE,
  SET_PERIPHERAL_ERROR,
  SET_DETECTED_DEVICES,
  SET_HAS_VIOLATING_DEVICES,
  SET_CHECKING_DEVICES,
  SET_LAST_CHECK_TIME,
  RESET_PERIPHERAL,
} from "./actionTypes";

const initialState = {
  isPeripheralRestrictionActive: false,
  peripheralError: null,
  detectedDevices: [], // Simplified: just an array of detected devices
  hasViolatingDevices: false,
  isCheckingDevices: false,
  lastCheckTime: null,
};

const peripheralReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PERIPHERAL_RESTRICTION_ACTIVE:
      return {
        ...state,
        isPeripheralRestrictionActive: action.payload,
      };

    case SET_PERIPHERAL_ERROR:
      return {
        ...state,
        peripheralError: action.payload,
      };

    case SET_DETECTED_DEVICES:
      return {
        ...state,
        detectedDevices: action.payload,
      };

    case SET_HAS_VIOLATING_DEVICES:
      return {
        ...state,
        hasViolatingDevices: action.payload,
      };

    case SET_CHECKING_DEVICES:
      return {
        ...state,
        isCheckingDevices: action.payload,
      };

    case SET_LAST_CHECK_TIME:
      return {
        ...state,
        lastCheckTime: action.payload,
      };

    case RESET_PERIPHERAL:
      return initialState;

    default:
      return state;
  }
};

export default peripheralReducer;
